import React from "react";
import PropTypes from "prop-types";
import noop from "lodash/noop";
import classNames from "classnames";
import s from "./ContentButton.pcss";

/**
 * A button with default styles removed so that it simply wraps the children provided.
 */
const ContentButton = (props) => (
    <button
        {...props}
        className={classNames(s.button, props.className)}
        onClick={props.onClick}
        data-test-id="content-button"
    >
        {props.children}
    </button>
);

ContentButton.propTypes = {
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func,
};

ContentButton.defaultProps = {
    onClick: noop,
};

export default ContentButton;
